import type { BatchJobKindView } from "../../batch_job_kind_contract";
import { AdmissionRecheckPanel } from "./AdmissionRecheckPanel";

export { AdmissionRecheckParamsForm } from "./AdmissionRecheckParamsForm";
export { useAdmissionRecheckParams } from "./useAdmissionRecheckParams";
export type { UseAdmissionRecheckParamsResult } from "./useAdmissionRecheckParams";

export const ADMISSION_RECHECK_VIEW: BatchJobKindView = {
  label: "Admission re-check",
  Panel: AdmissionRecheckPanel,
};
